import React from 'react'

const DEFAULT_VALUE_PROP = "value";

export function valueDidUpdate(prevProps, props, valueProp = DEFAULT_VALUE_PROP) {
  if (_isFormField(props)) {
    return prevProps.formField.value !== props.formField.value
      || prevProps.formField.error !== props.formField.error;
  } else {
    return prevProps[valueProp] !== props[valueProp];
  }
}

export function getEffectDependencies(props, valueProp = DEFAULT_VALUE_PROP) {
  if (_isFormField(props)) {
    return [props.formField.value, props.formField.error];
  } else {
    return [props[valueProp]];
  }
}

export function _isFormField(props) {
  return props.formField;
}

export function isInvalid(props) {
  if (_isFormField(props)) {
    return props.formField.error;
  }
  return props.isInvalid;
}

export function errorMessage(props) {
  if (isInvalid(props)) {
    if (_isFormField(props)) {
      return props.formField.error;
    }
    return props.invalidMessage || "";
  }
  return "";
}

export function clearValidation(props) {
  if (_isFormField(props)) {
    return props.formField.clearValidation();
  }
}

export function getValue(props, propValue = DEFAULT_VALUE_PROP) {
  let val;
  if (_isFormField(props)) {
    val = props.formField.value;
  } else {
    val = props[propValue];
  }
  return typeof val !== "undefined" && val !== null ? val : "";
}

export function onChange(props, value) {
  if (_isFormField(props)) {
    props.formField.setValue(value, undefined, true);
  } else {
    props.onChange && props.onChange(value);
  }
}

export function onBlur(props) {
  if (_isFormField(props)) {
    props.formField.triggerValidation();
  }
  props.onBlur && props.onBlur();
}

export function getDataAttributes(props) {
  return Object.entries(props).reduce((attributes, [key, entry]) => {
    key.startsWith("data-") && (attributes[key] = entry);
    return attributes;
  }, {})
}


class Component extends React.Component {
  constructor(props) {
    super(props);
  }

  valueDidUpdate(prevProps) {
    return valueDidUpdate(prevProps, this.props, this.getValueProps())
  }

  isInvalid() {
    return isInvalid(this.props);
  }

  errorMessage() {
    return errorMessage(this.props);
  }

  getValue() {
    return getValue(this.props, this.getValueProps());
  }

  getValueProps() {
    return "value";
  }

  getEventValue(event) {
    return event.target.value;
  }

  onChange(event) {
    onChange(this.props, this.getEventValue(event));
  }

  onBlur() {
    onBlur(this.props);
  }
}

export default Component
